import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Skeleton } from 'antd';
import SectionTitle from 'components/SectionTitle';
import { Metric } from 'hooks/search';
import useDefaultChartsContainer from 'hooks/defaultChartsContainer';
import { useAuth } from 'hooks/auth';
import GenderChart from './GenderChart';
import { Container, ChartsContainer } from './styles';

const GenderContainer: React.FC = () => {
  const intl = useIntl();
  const { isUserLogged } = useAuth();

  const services = useMemo(() => {
    if (!isUserLogged) return ['facebook', 'instagram', 'misc'];
    return ['facebook', 'instagram', 'twitter', 'misc'];
  }, [isUserLogged]);

  const { paramsDatas, loading, searchedTerms } = useDefaultChartsContainer(
    '/historical_volume.json',
    {
      service: services,
      grouping: 'gender',
    },
  );

  const ContainerBody = useCallback(props => {
    if (props.numberOfCharts && props.numberOfCharts > 1) {
      return <ChartsContainer>{props.children}</ChartsContainer>;
    }
    return <>{props.children}</>;
  }, []);

  return (
    <Container
      title={
        <SectionTitle>
          {intl.formatMessage({ id: 'results.gender' })}
        </SectionTitle>
      }
    >
      <ContainerBody numberOfCharts={paramsDatas?.size}>
        {paramsDatas &&
          paramsDatas.size >= 1 &&
          searchedTerms.map(item => {
            const key = item.obligatory;
            const value = paramsDatas.get(key) as Metric[];
            return value ? (
              <GenderChart
                title={key}
                data={value}
                key={key}
                height={paramsDatas.size > 1 ? '250px' : undefined}
                width={paramsDatas.size > 1 ? '100%' : undefined}
              />
            ) : null;
          })}
        <Skeleton
          loading={loading}
          active
          title={false}
          paragraph={false}
          avatar={{
            size: paramsDatas && paramsDatas.size > 1 ? 180 : 250,
          }}
        />
      </ContainerBody>
    </Container>
  );
};

export default GenderContainer;
